import { render, staticRenderFns } from "./CryptoAddressList.vue?vue&type=template&id=3a8d82cc&"
import script from "./CryptoAddressList.vue?vue&type=script&lang=js&"
export * from "./CryptoAddressList.vue?vue&type=script&lang=js&"
import style0 from "./CryptoAddressList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports